import "core-js/modules/es.error.cause.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3636e48a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "promotions_details"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1));

const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};
const _hoisted_6 = {
  class: "base_details_date_picker"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "优惠设置", -1));

const _hoisted_8 = {
  class: "base_details_content_second"
};
const _hoisted_9 = {
  class: "money_box"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "满", -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元，减", -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关联产品", -1));

const _hoisted_14 = {
  class: "content"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "优惠区域", -1));

const _hoisted_16 = {
  class: "base_details_content_second"
};
const _hoisted_17 = {
  class: "base_details_title_button"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tb_title"
}, [/*#__PURE__*/_createTextVNode("产品设置"), /*#__PURE__*/_createElementVNode("b")], -1));

const _hoisted_19 = {
  class: "base_details_content_second"
};
import { $msg } from "@ui/msg";
import BackTitleView from "@com/BackTitleView.vue";
import UploadPicture from "@com/upload/UploadPicture.vue";
import ProductTable from "@com/marketing/ProductTable.vue";
import ProductTable2 from "@com/marketing/ProductTable2.vue";
import { ref, reactive } from "vue";
import $ from "@util/base";
import api from "@api/promotions";
import useRoute from "@util/router";
import productApi from "@/api/productChoose";
export default {
  __name: 'PromotionsDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    const readOnly = urlQuery.type == "show";
    var title = "活动详情";

    switch (urlQuery.type) {
      case "show":
        title = "活动详情";
        getDetails();
        break;

      case "add":
        title = "新增活动";
        break;

      case "modify":
        title = "修改活动";
        getDetails();
        break;

      case "add2":
        title = "二次编辑上架";
        getDetails();
        break;
    }

    const moneyTypeOptions = [{
      label: "满减",
      value: "1010001"
    }, {
      label: "折扣",
      value: "1010002"
    }];
    const typeOptions = [{
      label: "商品",
      value: "1003001",
      key: "goods"
    }, {
      label: "旅行",
      value: "1003002",
      key: "travel"
    }, {
      label: "酒店",
      value: "1003003",
      key: "hotel"
    }];
    const basicForm = ref({
      name: null,
      date: [],
      mainPic: [],
      itemPic: [],
      intro: null,
      moneyType: "1010001",
      moneyOff: {
        limitMoney: null,
        money: null
      },
      discountMoney: null,
      limitBusiType: "1003001",
      codeList: []
    });
    const addTableRef = ref(null);
    const showTableRef = ref(null);
    const typeKey = ref(null);
    const showTypeKey = ref(null);
    const drawer = ref(false);

    function openDrawer() {
      drawer.value = true;
    }

    function closeDrawer() {
      drawer.value = false;
    }

    function limitBusiTypeChange() {
      console.log("清空");
      showTableRef.value.empty();
      basicForm.value.codeList = [];
    }

    function addProduct() {
      let value = basicForm.value.limitBusiType;
      let index = typeOptions.findIndex(e => {
        return e.value === value;
      });
      typeKey.value = typeOptions[index].key;
      openDrawer();
    }

    function saveProduct() {
      const data1 = addTableRef.value.getSelectData();
      const data2 = showTableRef.value.getSelectData();

      if ($.isEmpty(data1)) {
        $msg.error("请勾选需要添加的产品");
      } else {
        let newData = data2.concat(data1);
        let uniqueList = Array.from(new Set(newData.map(item => item.code))).map(code => {
          return newData.find(item => item.code === code);
        });
        showTypeKey.value = typeKey.value;
        basicForm.value.codeList = uniqueList;
        closeDrawer();
      }
    }

    const checkMoneyOff = (rule, value, callback) => {
      if ($.isNull(basicForm.value.moneyOff.limitMoney) || $.isNull(basicForm.value.moneyOff.money)) {
        callback(new Error("请输入优惠内容"));
      }

      if (parseFloat(basicForm.value.moneyOff.money) > parseFloat(basicForm.value.moneyOff.limitMoney)) {
        callback(new Error("立减金额必须小于消费金额"));
      }

      return true;
    };

    const basicRules = {
      name: [{
        required: true,
        message: "请输入活动名称",
        trigger: "blur"
      }],
      date: [{
        required: true,
        type: "array",
        message: "请选择活动时间",
        trigger: "change"
      }],
      mainPic: [{
        required: true,
        message: "请上传活动封面",
        trigger: "blur"
      }],
      itemPic: [{
        required: true,
        message: "请上传活动列表图",
        trigger: "blur"
      }],
      intro: [{
        required: true,
        message: "请输入活动简介",
        trigger: "blur"
      }],
      moneyType: [{
        required: true,
        message: "请选择优惠形式",
        trigger: "change"
      }],
      moneyOff: [{
        required: true,
        validator: checkMoneyOff,
        trigger: "blur"
      }],
      discountMoney: [{
        required: true,
        message: "请输入优惠内容",
        trigger: "blur"
      }],
      limitBusiType: [{
        required: true,
        message: "请选择产品类型",
        trigger: "change"
      }]
    };

    const setDisableDate = time => {
      return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
    };

    const activeName = ref("basic");

    function tabChange(active) {
      if (active === "spec") {
        checkBasic(active);
      } else {
        activeName.value = active;
      }
    }

    const basicFormRef = ref(null);
    const discountsFormRef = ref(null);

    function checkBasic(active) {
      let check = [false, false];
      let p1 = basicFormRef.value.validate(valid => {
        if (valid) {
          check[0] = true;
        } else {
          check[0] = false;
        }
      });
      let p2 = discountsFormRef.value.validate(valid => {
        if (valid) {
          check[1] = true;
        } else {
          check[1] = false;
        }
      });
      Promise.all([p1, p2]).then(() => {
        if (check.every(function (e) {
          return e;
        })) {
          activeName.value = active;
        }
      });
    }

    function checkProduct() {
      if ($.isNotEmpty(basicForm.value.codeList)) {
        return true;
      } else {
        $msg.error("请添加产品");
        return false;
      }
    }

    function saveForm(type) {
      if (!checkBasic() && !checkProduct()) {
        return;
      }

      console.log("saveForm" + JSON.stringify(route.query().type));
      $.handleCRU(route.query().type, {
        add: () => {
          addData(type);
        },
        modify: () => {
          modifyData(type);
        },
        add2: () => {
          addData2(type);
        }
      });
    }

    function addData2(type) {
      console.log("addData2" + JSON.stringify(type));
      let newArr = basicForm.value.codeList.map(value => value.code);
      basicForm.value.codeList = newArr;
      console.log("  basicForm.value" + JSON.stringify(basicForm.value.codeList));
      api.add(type, basicForm.value, () => {
        $msg.succ("二次编辑上架成功");
        back();
      });
    }

    function addData(type) {
      let newArr = basicForm.value.codeList.map(value => value.code);
      console.log("  basicForm.value" + JSON.stringify(basicForm.value.codeList = newArr));
      api.add(type, basicForm.value, () => {
        $msg.succ("新增成功");
        back();
      });
    }

    function modifyData(type) {
      api.update(urlQuery.code, type, basicForm.value, () => {
        $msg.succ("修改成功");
        back();
      });
    }

    function getDetails() {
      api.details(urlQuery.code, val => {
        basicForm.value = val;
        let index = typeOptions.findIndex(e => e.value == val.limitBusiType);
        showTypeKey.value = typeOptions[index].key;
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      const _component_el_drawer = _resolveComponent("el-drawer");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => activeName.value = $event),
            type: "border-card",
            class: "base_details_tabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              name: "basic"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
                ref_key: "basicFormRef",
                ref: basicFormRef,
                model: basicForm.value,
                disabled: readOnly,
                rules: basicRules,
                "label-width": "100px",
                class: "base_details_form"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "活动名称",
                  prop: "name"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => basicForm.value.name = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "活动时间",
                  prop: "date"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_date_picker, {
                    modelValue: basicForm.value.date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => basicForm.value.date = $event),
                    type: "daterange",
                    "range-separator": "~",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": "YYYY-MM-DD 00:00:00",
                    "disabled-date": setDisableDate
                  }, null, 8, ["modelValue"])])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "活动列表图",
                  prop: "itemPic"
                }, {
                  default: _withCtx(() => [_createVNode(UploadPicture, {
                    modelValue: basicForm.value.itemPic,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => basicForm.value.itemPic = $event),
                    limit: 1,
                    disabled: readOnly,
                    fileSize: _unref($).imgFileSize()
                  }, null, 8, ["modelValue", "fileSize"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "活动封面",
                  prop: "mainPic"
                }, {
                  default: _withCtx(() => [_createVNode(UploadPicture, {
                    modelValue: basicForm.value.mainPic,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => basicForm.value.mainPic = $event),
                    limit: 1,
                    disabled: readOnly,
                    imgSize: _unref($).marketingSize(),
                    fileSize: _unref($).imgFileSize()
                  }, null, 8, ["modelValue", "imgSize", "fileSize"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "活动简介",
                  prop: "intro"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.intro,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => basicForm.value.intro = $event),
                    rows: 3,
                    type: "textarea",
                    resize: "none"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["model"])]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form, {
                ref_key: "discountsFormRef",
                ref: discountsFormRef,
                model: basicForm.value,
                disabled: readOnly,
                rules: basicRules,
                "label-width": "100px",
                class: "base_details_form"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "优惠形式",
                  prop: "moneyType"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: basicForm.value.moneyType,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => basicForm.value.moneyType = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(moneyTypeOptions, (item, index) => {
                      return _createVNode(_component_el_radio, {
                        key: index,
                        label: item.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), basicForm.value.moneyType === '1010001' ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "优惠内容",
                  prop: "moneyOff"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_input, {
                    modelValue: basicForm.value.moneyOff.limitMoney,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => basicForm.value.moneyOff.limitMoney = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"]), _hoisted_11, _createVNode(_component_el_input, {
                    modelValue: basicForm.value.moneyOff.money,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => basicForm.value.moneyOff.money = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"]), _hoisted_12])]),
                  _: 1
                })) : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "优惠内容",
                  prop: "discountMoney"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.discountMoney,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => basicForm.value.discountMoney = $event),
                    placeholder: "请输入折扣，例如：9.8"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }))]),
                _: 1
              }, 8, ["model"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "spec"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_13]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_form, {
                model: basicForm.value,
                disabled: readOnly,
                rules: basicRules,
                "label-width": "100px",
                class: "base_details_form"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "产品类型",
                  prop: "limitBusiType"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: basicForm.value.limitBusiType,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => basicForm.value.limitBusiType = $event),
                    onChange: limitBusiTypeChange
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, (item, index) => {
                      return _createVNode(_component_el_radio, {
                        key: index,
                        label: item.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["model"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, !readOnly ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: addProduct,
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("添加产品")]),
                _: 1
              })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createVNode(ProductTable2, {
                type: "show",
                ref_key: "showTableRef",
                ref: showTableRef,
                typeKey: showTypeKey.value,
                codeList: basicForm.value.codeList
              }, null, 8, ["typeKey", "codeList"])])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[11] || (_cache[11] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = $event => tabChange('spec')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = $event => tabChange('basic'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'spec']]), !readOnly ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[14] || (_cache[14] = $event => saveForm(0)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'spec']]) : _createCommentVNode("", true), !readOnly ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: _cache[15] || (_cache[15] = $event => saveForm(1)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存并发布 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'spec']]) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_drawer, {
        "custom-class": "base_drawer",
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => drawer.value = $event),
        "close-on-click-modal": false,
        title: "添加产品",
        "with-header": true,
        size: 720
      }, {
        footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
          onClick: closeDrawer
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: saveProduct,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(ProductTable, {
          type: "add",
          ref_key: "addTableRef",
          ref: addTableRef,
          typeKey: typeKey.value
        }, null, 8, ["typeKey"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};